"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChillEffectHandler = exports.ChillEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Slow_1 = require("./Slow");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
const enums_1 = require("../../enums");
const core_2 = require("../../event-handlers/core");
const DelayedDamage_1 = require("../../DelayedDamage");
const Target_1 = require("../../Target");
class ChillEffectArgs {
    constructor(primaryAttribute, power) {
        this.primaryAttribute = primaryAttribute;
        this.power = power;
        this.__type = EffectType_1.EffectType.Chill;
        this.__typeName = "Chill";
        this.name = "Chill";
        this.harmful = true;
    }
}
exports.ChillEffectArgs = ChillEffectArgs;
let ChillEffectHandler = class ChillEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, state.duration.type === enums_1.DurationType.Ticks ? EventType_1.EventType.Tick
            : EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new core_2.RecurringDamageEventHandlerArgs(state.creatorId, Target_1.Target.Self, new DelayedDamage_1.DelayedDamage(state.args.__typeName, state.args.primaryAttribute, "Frost", state.args.power)));
        state.meta.slowId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new Slow_1.SlowEffectArgs(1),
            duration: Duration_1.Duration.Permanent,
        });
        const frostVfx = new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "chest"), "Frost");
        state.meta.vfxStepArgsId = frostVfx.id;
        sequence.push(frostVfx);
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
        container.cancelEffect(sequence, state.meta.slowId);
        sequence.push(new core_1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
    }
};
ChillEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Chill)
], ChillEffectHandler);
exports.ChillEffectHandler = ChillEffectHandler;
